const DispatchAdvice = {

    // FIELDS
    "sales_order": "Sales Order",
    "dispatch": "Dispatch",
    "pending": "Pending",
    "item": "Item",
    "rate": "Rate",
    "quantity": "Quantity",
    "unit": "Unit",
    "sub_total": "Sub Total",
    "discount": "Discount",
    "vat": "VAT",
    "remark": "Remark",
    "total": "Total",
    "search": "Search",
    "delivery_date": "Delivery Date",

    // BUTTON
    "confirm": "Confirm",

    // PAGE HEADER
    "dipatch_advice": "Dispatch Advice",

    // TOOLTIP
    "approve": "Approve",
    "reject": "Reject",

    // SWEET ALERT
    "approve_confirm_text": "Are You Sure Want To Approve Dispatch Advice?",
    "reject_confirm_text": "Are You Sure Want To Reject Dispatch Advice?",
    "status": "Status",
    "status_text": "Status Successfully Changed",

    // ERROR
    "error_so": "Select Sales Order",
    "error_item": "Select Item",
    "error_qty": "Enter Quantity",
    "error_qty_positive": "Quantity Should be Positive",
    "error_item_nf": "Item Not Found",

    // TABLE HEADER
    "table_so_code": 'SO CODE',
    "table_da_code": "DA CODE",
    "table_booking_date": 'BOOKING DATE',
    "table_delivery_date": "DELIVERY DATE",
    "table_customer": "CUSTOMER",
    "table_status": "STATUS",
}

export default DispatchAdvice;